import React, { PureComponent } from "react";

import styles from "./Webtool.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class WebtoolComponent extends PureComponent {
  renderFetching() {
    return (
      <ul className={classnames(styles.list, styles.webtools_list, "grid-x")}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(el => (
          <li key={`tool${el}`} className="cell small-4">
            <div className={styles.item} />
          </li>
        ))}
      </ul>
    );
  }

  renderFetchingFav() {
    return (
      <ul className={classnames(styles.list, styles.webtools_list, "grid-x")}>
        {[1, 2, 3, 4, 5, 6].map(el => (
          <li key={`fav${el}`} className="cell small-4">
            <div className={styles.item} />
          </li>
        ))}
      </ul>
    );
  }

  renderWebtools() {
    const { webtools, lng, fetching, setFav, plusActivated } = this.props;
    const attr = `title${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
    const url = `urlName${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <div className={styles.webtoolsContainer}>
        {fetching ? (
          this.renderFetching()
        ) : (
          <ul
            className={classnames(styles.list, styles.webtools_list, "grid-x")}
          >
            {webtools.map(webtool => (
              <li className="cell small-4">
                <a
                  href={webtool[url]}
                  target="_blanck"
                  className={classnames(
                    styles.tool,
                    plusActivated ? styles.activated : ""
                  )}
                  onClick={setFav.bind(this, webtool)}
                >
                  <div className={styles.item}>
                    <i className={`icon webtool-${webtool.icon}`} />
                    <span>{webtool[attr]}</span>
                  </div>
                  <span className={classnames(styles.action, styles.plus)} />
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  renderFavorites() {
    const { lng, fetchingFav, favorites, setFav, minusActivated } = this.props;
    const attr = `title${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
    const url = `urlName${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    if (fetchingFav) {
      return this.renderFetchingFav();
    }

    return (
      <ul className={classnames(styles.list, "grid-x")}>
        {favorites.map(webtool => (
          <li className="cell small-4">
            <a
              href={webtool[url]}
              target="_blanck"
              className={classnames(
                styles.favorite,
                minusActivated ? styles.activated : ""
              )}
              onClick={setFav.bind(this, webtool)}
            >
              <div className={styles.item}>
                <i className={`icon webtool-${webtool.icon}`} />
                <span>{webtool[attr]}</span>
              </div>
              <span className={classnames(styles.action, styles.minus)} />
            </a>
          </li>
        ))}
      </ul>
    );
  }

  renderFetchingCat() {
    return (
      <ul className={classnames(styles.fetchingCat, "cell small-9")}>
        <li className={styles.category} />
        <li className={styles.category} />
        <li className={styles.category} />
        <li className={styles.category} />
        <li className={styles.category} />
      </ul>
    );
  }

  renderCategories() {
    const { lng, fetchingCat, categories, applyCategory, filter } = this.props;

    if (fetchingCat) {
      return this.renderFetchingCat();
    }
    if (!categories || categories.length === 0) {
      return null;
    }

    const { categoryId } = filter;

    const attr = `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;

    return (
      <ul className={"cell small-9"}>
        <li
          className={classnames(
            styles.category,
            !categoryId || categoryId === 0 ? styles.activated : ""
          )}
          onClick={applyCategory.bind(this, 0)}
        >
          {_("All")}
        </li>
        {categories.map(category => (
          <li
            className={classnames(
              styles.category,
              categoryId && categoryId === category.id ? styles.activated : ""
            )}
            onClick={applyCategory.bind(this, category.id)}
          >
            {category[attr]}
          </li>
        ))}
      </ul>
    );
  }

  showSearchInput = e => {
    let webtoolsSeatchInput = document.getElementById("webtools-search")
      .classList;
    let current = e.currentTarget.classList;
    if (webtoolsSeatchInput.contains(styles.activated)) {
      webtoolsSeatchInput.remove(styles.activated);
      current.remove("icon-close");
      current.add("icon-magnifier");
    } else {
      webtoolsSeatchInput.add(styles.activated);
      document.getElementById("webtools-search").focus();
      current.remove("icon-magnifier");
      current.add("icon-close");
    }
  };

  render() {
    const {
      favorites,
      clickMinus,
      clickPlus,
      plusActivated,
      minusActivated,
      searchWebtool
    } = this.props;

    const hadFavorites = favorites.length > 0;

    return (
      <div className={styles.webtool}>
        <div className={styles.favorites}>
          <div className={styles.favoritesHead}>
            <div className={styles.title}>
              <h5>{_("LISTES DES Favories")}</h5>
              <span>({!hadFavorites ? _("Empty") : favorites.length})</span>
            </div>
            <div className={styles.actions}>
              {hadFavorites ? (
                <span
                  id="webtoolMinus"
                  className={classnames(
                    styles.minus,
                    styles.action,
                    minusActivated ? styles.activated : ""
                  )}
                  onClick={clickMinus.bind(this)}
                />
              ) : null}
              <span
                id="webtoolPlus"
                className={classnames(
                  styles.plus,
                  styles.action,
                  plusActivated ? styles.activated : ""
                )}
                onClick={clickPlus.bind(this)}
              />
            </div>
          </div>
          {this.renderFavorites()}
        </div>
        <div className={styles.body}>
          <div className={classnames(styles.categories, "grid-x")}>
            {this.renderCategories()}
            <div className={classnames(styles.search, "cell small-3")}>
              <input
                type="text"
                id="webtools-search"
                placeholder={_("Search...")}
                onChange={searchWebtool.bind(this)}
              />
              <i
                className="icon icon-magnifier"
                onClick={this.showSearchInput.bind(this)}
              />
            </div>
          </div>
          {this.renderWebtools()}
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/Common/Webtool/WebtoolComponent.js